<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 text-center md:p-12"
>
  <h2 class="text-3xl font-bold md:text-4xl">
    Ready to automate your publishing?
  </h2>
  <p class="text-balance text-xl">
    Set up automated app store publishing in minutes. Connect your store
    accounts and start publishing to TestFlight, Apple App Store, and Google
    Play with one click. Choose a plan that fits your needs.
  </p>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col justify-center gap-4 sm:flex-row">
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="app-store-publishing-cta-get-started-button"
      >
        Get started
      </a>
      <a
        appearance="outline"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="app-store-publishing-cta-booking-demo-button"
      >
        Book a demo
      </a>
    </div>
    <p class="text-text-tertiary text-sm">
      Questions?
      <a
        class="text-primary hover:underline"
        [href]="discordUrl"
        target="_blank"
      >
        Join our Discord
      </a>
      or
      <a class="text-primary hover:underline" routerLink="/contact/">
        contact us </a
      >.
    </p>
  </div>
</section>
